export default __webpack_public_path__ + "static/media/Zara_Zamani_2_AHV_In_Moms_We_Trust.10aceba8.jpg";